// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__3GEWW","item":"Tags_item__vF4eC","tag":"Tags_tag__2wxlK","scroll_controls":"Tags_scroll_controls__2HcnM"};